import DualListSelect from './dualListSelect.container';

export default DualListSelect;
